/* eslint-disable import/prefer-default-export */
import type { FormikHelpers, FormikConfig } from 'formik'
import { SystemLogs } from '../components'
import type { AlertSettingsState } from '..'
import type { StepProps } from '../../models'
import { map, filter } from 'lodash'
import type { SysLogsDict } from '../../helpers/sys.log.helper'
import { toastSuccess } from '@src/utils/toast'
import type { AlertSeverityEnum } from '@src/endpoints/services/commonHdr.service'

export interface AlertSettingsValues {
  severity: AlertSeverityEnum
  slackChannelUrl?: string[]
  notification_email_id?: string[]
  syslog_servers?: SysLogsDict
}

export interface GetAlertSettingsConfig {
  initialValues: AlertSettingsValues
  stepProps: StepProps
  state: AlertSettingsState
}

export const submitAction = (options: {
  stepProps: StepProps
  values: AlertSettingsValues
}) => {
  const { stepProps, values } = options
  const { notificationSettings = {}, severity } = { ...stepProps }
  notificationSettings.severity = values.severity
  notificationSettings.email = values.notification_email_id
  notificationSettings.syslog = map(
    filter(values.syslog_servers, ({ id }) =>
      SystemLogs.isValidSysLog(id, values.syslog_servers)
    ),
    ({ data: { ip, port, network, credentials } }) => ({
      endpoint: `${ip}:${port}`,
      network,
      credentials
    })
  )
  notificationSettings.slack_url = values.slackChannelUrl

  stepProps.updateNotifications(severity, notificationSettings, () => {
    toastSuccess('Alert data has been changed')
  })
}

export const getAlertSettingsFormConfig = ({
  initialValues,
  stepProps,
  state
}: GetAlertSettingsConfig): FormikConfig<AlertSettingsValues> => ({
  initialValues,
  enableReinitialize: true,
  onSubmit: (
    values: AlertSettingsValues,
    formikHelpers: FormikHelpers<AlertSettingsValues>
  ) => {
    submitAction({ stepProps, values })
  }
})
